import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalConstants } from '../global-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  dloUser = GlobalConstants.dloUser;
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(localStorage.getItem('RoleName')=== this.Moderator || localStorage.getItem('RoleName')==this.Publisher)
      return true;
    else
      return false;
  }

}
